import React, { useEffect, useMemo } from "react";
import styled, { keyframes } from "styled-components";
import { curStateMiniGame } from "../../../../Redux/selector";
import { useDispatch, useSelector } from "@pages/Events/MiniGame/store";
import _ from "lodash";
import { ID_GIFT_PLAY_LOTO } from "../../../../helper/const";
import { getDataSpinHistoryMiniGame } from "../../../../Redux/futures/mini-game/action";
import Marquee from "react-fast-marquee";

function EventMarquee() {
  const statusMiniGame = useSelector(curStateMiniGame)?.configMiniGame;
  const dataHistory =
    useSelector(curStateMiniGame).dataSpinHistoryMini?.resultLast;

  const dispatch = useDispatch();

  const handleGetData = async () => {
    if (!statusMiniGame?.minigame?.id) {
      return null;
    }
    const data = {
      my_history: 0,
      limit: 5,
      page: 1,
      minigame_id: statusMiniGame?.minigame?.id,
    };
    dispatch(getDataSpinHistoryMiniGame(data));
  };

  useEffect(() => {
    handleGetData();
  }, [statusMiniGame]);


  const context =
    useMemo(() => {
      if (_.isEmpty(dataHistory)) {
        return null;
      }

      const contentActive = dataHistory?.filter((item) => item?.award_name !== "Good luck" && item?.spin_award_id !== 1)?.map((itemDataHistory) => {
        let content = "";
        switch (+itemDataHistory?.spin_award_id) {
          case ID_GIFT_PLAY_LOTO.bid_free:
            if (+itemDataHistory?.award_value === 1) {
              content = `${itemDataHistory?.isdn} ganó 1 puja gratis`;
            } else {
              content = `${itemDataHistory?.isdn} ganó 2 pujas gratis`;
            }
            return content;

          case ID_GIFT_PLAY_LOTO.puzzle_piece:
            content = `${itemDataHistory?.isdn} ganó ${itemDataHistory?.award_name} - Pieza (${itemDataHistory?.name}).`;
            return content;

          case ID_GIFT_PLAY_LOTO.add_spin:
            content = `${itemDataHistory?.isdn} ganó ${itemDataHistory?.award_value} monedas gratis`;
            return content;

          default:
            break;
      }
        return content;
    });
  return contentActive;
}, [dataHistory]) || [];

if (_.isEmpty(dataHistory)) {
  return <MarqueeContainer />;
}

return (
  <MarqueeContainer>
    <Marquee className="marquee">
      {_.isEmpty(context)
        ? null
        : context.map((item, index) => (
          <p className='marquee-text' key={`${item}_${index}`}>
            {item}
          </p>
        ))}
    </Marquee>
  </MarqueeContainer>
);
}

const marquee = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const MarqueeContainer = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px 0;
  margin-bottom: 12px;
  position: relative;
  z-index: 2;
  .marquee {
    /* display: inline-block;
    animation: ${marquee} 20s linear infinite;
    width: max-content; */
    overflow-x: unset;

    .marquee-text {
      color: white;
      display: inline-block;
      margin-right: 40px;
    }
  }
`;

// const Marquee = styled.div`
// `;

export default EventMarquee;
